import { useEffect, useState, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Dropdown, Grid, Menu } from "antd";
import axios from "axios";
import PatientInfo from "../../doctor/PatientInfo";
import AddPatientPopup from "../../appointmentBooking/AddPatientPopUp";
import VitalsModal from "../../doctor/VitalsModal";
import { doctorDashboard, logo } from "../../imagepath";
import PatientQueue from "../../doctor/PatientQueue";
import PatientDetails from "../../doctor/PatientDetails";
import { Link } from "react-router-dom";
import {
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons"; // optional icon
import { useAuth } from "../../../services/authentication_API/authService";
import VitalsDisplay from "../../patients/Vitals_display";
import Lab_PatientsQueue from "./Lab_PatientsQueue";
import Patients_report_detail from "./Patients_report_detail";

const { useBreakpoint } = Grid;

const LabDashboard = () => {
  const { logout, user, userData } = useAuth();

  const screens = useBreakpoint();
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([
    { value: 1, label: "This Week" },
    { value: 2, label: "Last Week" },
    { value: 3, label: "This Month" },
    { value: 4, label: "Last Month" },
  ]);
  const [year, setyear] = useState([
    { value: 1, label: "2022" },
    { value: 2, label: "2021" },
    { value: 3, label: "2020" },
    { value: 4, label: "2019" },
  ]);
  const [stats, setStats] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const [selectedPatient, setSelectedPatient] = useState(null);
  const [vitalDates, setVitalDates] = useState(["01 May, 2025"]);
  const [isVitalsModalVisible, setIsVitalsModalVisible] = useState(false);
  const [appoimentBooked, setAppoimentBooked] = useState(true);

  useEffect(() => {
    axios
      .get("/json/appoiments/appoiment.json")
      .then((res) => setStats(res.data.count))
      .catch((err) => console.error("Error loading stats:", err));
  }, []);

  const handleAddPatient = useCallback(() => {
    setShowPopup(true);
  }, []);

  const handleClosePopup = useCallback(() => {
    setShowPopup(false);
    return false;
  }, []);

  const handlePatientSelect = (patient) => {
    setSelectedPatient(patient);
    console.log("Selected Patient:", patient);
  };

  const handleVitalsClick = () => {
    setIsVitalsModalVisible(true);
  };

  const handleAddNewDate = (date) => {
    if (!vitalDates.includes(date)) {
      setVitalDates([...vitalDates, date]);
    }
  };

  const handleVitalsClose = () => {
    setIsVitalsModalVisible(false);
  };

  const handleVitalsSubmit = (formValues) => {
    console.log("Submitted Vitals Form Values:", formValues);
    setIsVitalsModalVisible(false);
  };

  // Responsive font sizes
  const getFontSize = (base, sm, xs) => {
    if (screens.xs) return xs;
    if (screens.sm) return sm;
    return base;
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, []);

  const menu = (
    <Menu>
      {/* View Profile */}
      <Menu.Item key="view-profile" icon={<UserOutlined />}>
        <Link to="/doctor-profile">View Profile</Link>
      </Menu.Item>
      {/* Doctor Settings submenu */}
      <Menu.SubMenu
        key="doc-settings"
        title="Doctor Settings"
        icon={<SettingOutlined />}
      >
        <Menu.Item key="8">
          <Link to="/receptionistlist">Reception</Link>
        </Menu.Item>
        <Menu.Item key="9">
          <Link to="/manage-shifts">Doctor Schedule</Link>
        </Menu.Item>
        {/* <Menu.Item key="10">
          <Link to="/Appointment-Settings">Appointment Settings</Link>
        </Menu.Item> */}
        {/* <Menu.Item key="11">
          <Link to="/consultantion-fee">Consultantion Fee</Link>
        </Menu.Item> */}
      </Menu.SubMenu>

      {/* Advanced Settings submenu */}
      <Menu.SubMenu
        key="adv-settings"
        title="Advanced Settings"
        icon={<SettingOutlined />}
      >
        <Menu.Item key="1">
          <Link to="/medicines-Settings">Medicines</Link>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to="/symptoms-Settings">Symptoms</Link>
        </Menu.Item>
        <Menu.Item key="3">
          <Link to="/instructions-Settings">Instructions</Link>
        </Menu.Item>
        <Menu.Item key="4">
          <Link to="/procedures-Settings">Procedures</Link>
        </Menu.Item>
        <Menu.Item key="5">
          <Link to="/findings-Settings">Findings</Link>
        </Menu.Item>
        <Menu.Item key="6">
          <Link to="/diagnoses-Settings">Diagnoses</Link>
        </Menu.Item>
        <Menu.Item key="7">
          <Link to="/investigations-Settings">Investigations</Link>
        </Menu.Item>
      </Menu.SubMenu>
      <Menu.Item key="logout" icon={<LogoutOutlined />}>
        <Link onClick={logout} to="/login">
          Log Out
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {isVitalsModalVisible && (
        <VitalsDisplay
          isVisible={isVitalsModalVisible}
          onClose={handleVitalsClose}
          onSubmit={handleVitalsSubmit}
        />
      )}
      <div className="dashboard-container">
        <div
          style={{
            height: "100dvh",
            maxHeight: "100dvh",
            // overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            background: "#f5f5f5",
          }}
        >
          {/* Main Dashboard Card */}
          <div className="card h-100 d-flex flex-column shadow-sm border-0 mb-0">
            <div className="card-body p-0 d-flex flex-column overflow-hidden">
              <Container
                fluid
                className="p-0 h-100 d-flex flex-column"
                style={{ minHeight: 0 }}
              >
                {/* Header Row */}
                {/* <Row className="m-0 flex-shrink-0">
                  <Col
                    xs={12}
                    md={4}
                    className="p-0 border-end border-bottom"
                    style={{
                      minHeight: screens.xs ? "80px" : "100px",
                      background: "#fff",
                    }}
                  >
                    <div className="hospital-header h-100">
                      <div className="d-flex align-items-center p-3 h-100">
                        <div className="hospital-logo">
                          <img
                            style={{
                              width: getFontSize("50px", "45px", "40px"),
                              height: getFontSize("50px", "45px", "40px"),
                            }}
                            src={logo || "/placeholder.svg"}
                            alt="Hospital Logo"
                          />
                        </div>
                        <div className="hospital-name ms-2 flex-grow-1">
                          <h4
                            className="mb-0"
                            style={{
                              fontSize: getFontSize("1.25rem", "1.1rem", "1rem"),
                              lineHeight: "1.2",
                              fontWeight: "600",
                            }}
                          >
                            Shri Ram Sarvajanik Hospital
                          </h4>
                        </div>
                        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
                        <button
                          className="btn btn-light ms-auto"
                          style={{
                            width: getFontSize("40px", "36px", "32px"),
                            height: getFontSize("40px", "36px", "32px"),
                            padding: "0",
                            fontSize: getFontSize("16px", "14px", "12px"),
                          }}
                        >
                          <i className="fa fa-cog"></i>
                          
                        </button>
                        </Dropdown>
                      </div>
                    </div>
                  </Col>

                  <Col
                    xs={12}
                    md={8}
                    className="p-0 border-bottom"
                    style={{
                      minHeight: screens.xs ? "80px" : "100px",
                      background: "#fff",
                    }}
                  >
                    <PatientInfo patient={selectedPatient} />
                  </Col>
                </Row> */}

                {/* Main Content Row */}
                <Row className="m-0 flex-grow-1" style={{ minHeight: 0 }}>
                  {/* Left Column: Patient Queue (Row span = 2) */}
                  <Col
                    xs={12}
                    md={4}
                    className="p-0 border-end d-flex flex-column"
                    style={{
                      height: screens.xs ? "auto" : "100%",
                      background: "#fff",
                    }}
                  >
                    <div
                      className="h-100"
                      style={{
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Lab_PatientsQueue
                        onPatientSelect={handlePatientSelect}
                        appoimentBooked={appoimentBooked}
                        setAppoimentBooked={setAppoimentBooked}
                      />
                    </div>
                  </Col>

                  {/* Right Column with 2 Rows */}
                  <Col
                    xs={12}
                    md={8}
                    className="p-0 d-flex flex-column"
                    style={{
                      height: screens.xs ? "auto" : "100%",
                      background: "rgb(250, 250, 250)",
                    }}
                  >
                    {/* Row 1: Patient Info */}
                    <Row
                      className="m-0 flex-shrink-0 border-bottom"
                      style={{ background: "#fff" }}
                    >
                      <Col className="p-0">
                        <PatientInfo patient={selectedPatient} />
                      </Col>
                    </Row>

                    {/* Row 2: Patient Details */}
                    {/* Row 2: Patient Details */}
                    <Row className="m-0 flex-grow-1" style={{ minHeight: 0 }}>
                      <Col
                        className="p-0 d-flex flex-column"
                        style={{
                          minHeight: 0,
                          height: "100%", // Important
                          overflow: "hidden", // Prevents spilling
                        }}
                      >
                        {selectedPatient ? (
                          <div
                            style={{
                              flexGrow: 1,
                              minHeight: 0,
                              overflowY: "auto", // <--- SCROLLS INTERNALLY
                              overflowX: "hidden",
                            }}
                          >
                            <Patients_report_detail
                              patient={selectedPatient}
                              appoimentBooked={appoimentBooked}
                              setAppoimentBooked={setAppoimentBooked}
                              onVitalsClick={handleVitalsClick}
                            />
                          </div>
                        ) : (
                          <div className="welcome-screen d-flex flex-column align-items-center justify-content-center h-100 text-center px-3">
                            <h2
                              className="welcome-heading mb-3"
                              style={{
                                fontSize: getFontSize(
                                  "2rem",
                                  "1.75rem",
                                  "1.5rem"
                                ),
                                fontWeight: "600",
                              }}
                            >
                              Welcome to{" "}
                              <span style={{ color: "#2e37a4" }}>Hospytl</span>,{" "}
                              {userData?.name} {userData?.last_name}
                            </h2>
                            <p
                              className="text-muted welcome-subtext mb-4"
                              style={{
                                fontSize: getFontSize(
                                  "1rem",
                                  "0.9rem",
                                  "0.85rem"
                                ),
                                maxWidth: "500px",
                              }}
                            >
                              Get started by adding patients to the queue or
                              searching your patients on the left sidebar
                            </p>
                            <img
                              src={doctorDashboard}
                              alt="Welcome illustration"
                              className="my-4 img-fluid"
                              style={{
                                maxWidth: "100%",
                                height: "auto",
                                maxHeight: getFontSize(
                                  "300px",
                                  "250px",
                                  "200px"
                                ),
                              }}
                            />
                            {/* <button
                              className="btn btn-primary"
                              onClick={handleAddPatient}
                              style={{
                                fontSize: getFontSize(
                                  "1rem",
                                  "0.9rem",
                                  "0.85rem"
                                ),
                                padding: getFontSize(
                                  "12px 24px",
                                  "10px 20px",
                                  "8px 16px"
                                ),
                                background: "#2e37a4",
                                border: "none",
                              }}
                            >
                              Add Patient
                            </button> */}
                            {showPopup && (
                              <AddPatientPopup
                                show={showPopup}
                                handleClose={handleClosePopup}
                              />
                            )}
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LabDashboard;
